import { Box } from "@mui/material";
import useScrollTransition from "../useScrollTransition";
import DissertationFlow from "./dissertationpage3";
import ServicesComponent from "./dissertationpage3";
import Desseratationabout from "./dissertationpage1";
import RotatingCards from "./dissertationpage2";
import EntrepreneurHero, { DesseratationProposals } from "./dissertationpage5";
import ImageCarousel from "./dissertationpage6";
import DissertationProcess from "./dissertationpage7";
import ServiceContent from "./dissertationpage4";
import ScrollBoxes from "./dissertationpage8";
import ScrollBoxes2 from "./dissertationpage8";
import CircularText from "./dissertationpage7";
import Layout from "../components/Layout";
import DissertationInfographic from "./dissertationpage4";
import MastersDissertationServices from "./dissertationpage8";
import TopicCardsGrid from "./dissertationpage4";
import DissertationServicePage from "./dissertationpage8";
import HomePage from "./dissertationpage1";
import WhyChooseOurDessertation from "./dissertationpage3";
import DessertationHomePage from "./dissertationpage1";
import DessertationCustomTopics from "./dissertationpage2";
import OurSpealizationTopic from "./dissertationpage4";
import DessertationGuidance from "./dissertationpage6";
import DessertationDataAnalysis from "./dissertationpage7";
import DessertationProofReading from "./dissertationpage8";




const DisserationServicepg = () => {
    useScrollTransition();
    return (
      <>
      <Layout>
      <Box sx={{backgroundColor:"#f3f4f6"}}>
        <DessertationHomePage />
        <DessertationCustomTopics />
        <WhyChooseOurDessertation />
        <OurSpealizationTopic />
        <DesseratationProposals />
        <DessertationGuidance />
        <DessertationDataAnalysis />
        <DessertationProofReading />
      </Box>
      </Layout>
      </>
    );
  };
  
  export default DisserationServicepg;